import { render } from "./AccountReceivable.vue?vue&type=template&id=453bf7d9"
import script from "./AccountReceivable.vue?vue&type=script&lang=js"
export * from "./AccountReceivable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AccountReceivable/AccountReceivable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453bf7d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453bf7d9', __exports__)) {
    api.reload('453bf7d9', __exports__)
  }
  
  module.hot.accept("./AccountReceivable.vue?vue&type=template&id=453bf7d9", () => {
    api.rerender('453bf7d9', render)
  })

}


export default __exports__